<label *ngIf="label !== ''"
    >{{ label }}<span *ngIf="required" class="color-weak"> *</span></label
>
<div class="input-error {{ errorClass }}">
    <rr-icon name="octagon"></rr-icon>
    <span *ngIf="control.hasError('required')" i18n
        >This field is required</span
    >
    <span *ngIf="!control.hasError('required')" i18n
        >Your input is not valid</span
    >
</div>

<rr-btn
    class="space-between disabled-{{ disabled }} {{ errorClass }}"
    size="medium"
    type="secondary"
    iconEnd="chevron-down"
    (click)="toggleOptions($event.target)"
    (keydown.enter)="toggleOptions($event.target)"
    (keydown.space)="toggleOptions($event.target)"
    (blur)="onTouched()"
    >{{ selectedName || "Select " + label }}</rr-btn
>

<div class="backdrop" (click)="onBackdropClick()" *ngIf="showOptions"></div>
<div
    class="selectoptions {{ errorClass }}"
    *ngIf="showOptions"
    [style.width]="elementWidth"
>
    <div
        class="selectoption"
        [class.active]="focusedOptionIndex === i"
        *ngFor="let option of options; let i = index"
        (click)="selectOption(option)"
    >
        <rr-icon *ngIf="option?.icon" [name]="option.icon"></rr-icon>
        {{ option[optionName] }}
    </div>
</div>
